import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthLayout } from '../components/AuthLayout';
import { routePaths } from '@/app/routes';

/**
 * Placeholder — the request/OTP/reset flow (POST /password-reset/request,
 * /password-reset/reset-with-otp) will be implemented as a follow-up screen.
 */
export function ForgotPasswordPage() {
  const { t } = useTranslation();
  return (
    <AuthLayout>
      <header className="mb-4 text-center">
        <h1 className="text-lg font-bold text-ink">{t('auth.login.forgot')}</h1>
        <p className="mt-1 text-sm text-ink-mute">În curând.</p>
      </header>
      <Link to={routePaths.login} className="block text-center text-sm font-medium text-primary hover:underline">
        ← {t('common.back')}
      </Link>
    </AuthLayout>
  );
}
